import { urlToBase64 } from "src/app/utils/utils.common";
import * as moment from "moment-timezone";

export async function isiReportDownload(data, user,configuration, preSpaceTypes, selectedCorporate) {
  const invoiceNumber  = configuration.invoiceNo;
  const urlBase64 = user.profileImageURL
    ? await urlToBase64(user.profileImageURL)
    : "";
  //  ..calculate total fare 
  let totalFare = data.reduce((sum, trip) => {
    const fare = parseFloat(trip.preSpecialRate) || 0;
    return sum + fare;
  }, 0);

  const subTotal = parseInt(totalFare) + parseInt(configuration.corrections || 0);
  
  totalFare = subTotal;


  // Build rows dynamically
  const tripRows = data.map((trip, index) => [
    { text: moment(trip.scheduleTime).format('MM-DD-YYYY'), fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    { text: trip.priorityClient.displayName, fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    {
      stack: [
        { text: [{ text: "Vehicle ID: ", bold: true }, trip.fleet.slice(-6)] },
        { text: [{ text: "Driver: ", bold: true }, trip.driver.displayName || "N/A"] }
      ],
      fontSize: 9,
      fillColor: index % 2 === 0 ? "#ededed" : null,
    },
    { text: preSpaceTypes && preSpaceTypes[trip.spaceType] ? preSpaceTypes[trip.spaceType].title : 'N/A', fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    { text: trip.priorityClient.clientId, fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null },
    {
      stack: [
        { text: [{ text: "Trip ID: ", bold: true }, trip.tripId] },
        { text: [{ text: "PU: ", bold: true }, trip.jobOriginAddress] },
        { text: [{ text: "Actual PU Time: ", bold: true },trip.trackInfoJob.jobAccepted.time ? moment(trip.trackInfoJob.jobAccepted.time).format("HH:mm") : "N/A"]},
        { text: [{ text: "DO: ", bold: true }, trip.jobDestinationAddress] },
        { text: [{ text: "Actual DO Time: ", bold: true }, moment(trip.trackInfoJob.jobCompleted.time).format("HH:mm")]},
        { text: [{ text: "Notes: ", bold: true }, `${trip.companyNote || 'N/A'}`] },
        { text: [{ text: "Distance: ", bold: true }, `${trip.milage || 0} mi`] }
      ],
      fontSize: 9,
      lineHeight: 1,
      fillColor: index % 2 === 0 ? "#ededed" : null,
    },
    { text: trip.preSpecialRate, fontSize: 9, fillColor: index % 2 === 0 ? "#ededed" : null }
  ]);

  // Split trips into chunks of 4 per page
  const chunkSize = 6;
  const tripTables = [];
  for (let i = 0; i < tripRows.length; i += chunkSize) {
    tripTables.push({
      style: "tableStyle",
      table: {
        headerRows: 1,
        widths: [50, 60, 70, 60, 60, "*", 50],
        body: [
          [
            { text: "Date", bold: true, fontSize: 8 },
            { text: "Passenger Info", bold: true, fontSize: 8 },
            { text: "Driver Info", bold: true, fontSize: 8 },
            { text: "Trip Mode", bold: true, fontSize: 8 },
            { text: "Member ID", bold: true, fontSize: 8 },
            { text: "Trip Info", bold: true, fontSize: 8 },
            { text: "Amount", bold: true, fontSize: 8 }
          ],
          ...tripRows.slice(i, i + chunkSize)
        ]
      },
      layout: {
        hLineWidth: (i, node) => (i === 0 ? 0 : 0.5),
        vLineWidth: () => 0,
        hLineColor: () => "#cccccc",
      },
      pageBreak: i + chunkSize < tripRows.length ? "after" : undefined, // add page break
      margin: [0, 50, 0, 0],
    });
  }

  return {
    pageSize: { width: 595.28 + 100, height: 841.89 },
    defaultStyle: { fontSize: 8},
    content: [
         {
      columns: [
       
       	{
			image: urlBase64,
			width: 60,
			height: 60,
		},
        { text: user.displayName, fontSize: 16, alignment:'center', bold: true, width: '60%' }, 
        {
          stack: [
            { text: "INVOICE", fontSize: 16, bold: true, margin: [0, 0, 0, 4] },
            { text: `Invoice No: ${invoiceNumber}`, fontSize: 8,lineHeight: 1.1, },
            { text: `Invoice Date: ${moment().tz(user.timeZone).format('MM-DD-YYYY')}`, fontSize: 8 ,lineHeight: 1.1,},
            { text: `Invoice Due Date: ${moment().tz(user.timeZone).add(1, 'week').format('MM-DD-YYYY')}`, fontSize: 8,lineHeight: 1.1, }
          ],
          alignment: 'left',
          width: '30%'
        }
      ]
    },
    // --- Client ---
    {
  margin: [0, 15, 0, 0],
  columns: [
    {
      stack: [
        {
          columns: [
            { text: "Client: ", bold: true, width: 30 },
            {
              stack: [
                { text: selectedCorporate.displayName, fontSize: 8},
                { text: selectedCorporate.address, fontSize:8, margin: [0, 2, 0, 0] }
              ],
              width: '*'
            }
          ]
        }
      ],
      width: '*',
    //   alignment: ''
    }
  ]
},
      ...tripTables, 


    // --- Totals section ---
    {
      columns: [
        { text: '', width: '*' }, 
        {
          width: 'auto',
          stack: [
            { text: [ { text: 'Total Items/Corrections: ', bold: true }, parseInt(configuration.corrections || 0) ], alignment: 'right' },
            { text: [ { text: 'Subtotal: ', bold: true }, subTotal ], alignment: 'right', margin: [0, 5, 0, 0] },
            { text: [ { text: 'Total: ', bold: true }, totalFare ], alignment: 'right', fontSize: 11, margin: [0, 10, 0, 0] }
          ]
        }
      ],
      margin: [0, 30, 0, 20],
    },
    // --- Outstanding Invoices Heading ---
    { text: 'Outstanding Invoices', bold: true, fontSize: 11, margin: [0, 0, 0, 5] },
    { canvas: [ { type: 'line', x1: 0, y1: 0, x2: 620, y2: 0, lineWidth: 1 } ], margin: [0, 0, 0, 5] },
    // --- Outstanding Invoices Row ---
    {
  columns: [
    { text: `Invoice No.: ${configuration.outstandingInvoiceNo}` },
    { text: `Invoice Due Date: ${moment(configuration.dueDate).tz(user.timeZone).add(1, 'week').format('MM-DD-YYYY')}` },
    {
      stack: [
        {
          columns: [
            { text: 'Past Due', color: 'red', bold: true, margin: [0, 0, 28, 0] },
            { text: `Balance: $${parseInt(configuration.pastDue || 0)}`, alignment: 'right' }
          ]
        }
      ],
      width: 'auto',
      alignment: 'right'
    }
  ],
  margin: [0, 0, 0, 20],
},

    // --- Balances (Right Side) ---
    {
      columns: [
        { text: '', width: '*' },
        {
          width: 'auto',
          stack: [
            { text: [ { text: 'Outstanding Balance: ', bold: true }, configuration.pastDue ], alignment: 'right' },
            { text: [ { text: 'Current Balance: ', bold: true }, totalFare ], alignment: 'right', margin: [0, 5, 0, 0] },
            { text: [ { text: 'Total Balance: ', bold: true }, totalFare + parseInt(configuration.pastDue || 0)], alignment: 'right', fontSize: 11, margin: [0, 10, 0, 0] }
          ]
        }
      ]
    },
    ],

    
  footer: function (currentPage, pageCount) {
    return {
      margin: [40, -50, 40, 0],
      stack: [
        {
          columns: [
            {
              width: '70%',
              stack: [
                { text: "DIRECT ALL INQUIRIES TO:", bold: true, fontSize: 9 },
                { text: user.focalPerson ? user.focalPerson.displayName : '', fontSize: 8, margin: [0, 2, 0, 0] },
                { text: user.focalPerson ? user.focalPerson.contactNumber : '', fontSize: 8 },
                { text: user.email, fontSize: 8 }
              ],
              alignment: 'left'
            },
            {
              width: '30%',
              stack: [
                { text: "MAKE ALL CHECKS PAYABLE TO:", bold: true, fontSize: 9 },
                { text: user.displayName, fontSize: 8, margin: [0, 2, 0, 0]},
                { text: user.address, fontSize: 8 }
              ],
              alignment: 'left'
            }
          ]
        },
        {
          columns: [
            { text: "Powered by NEMT Platform", alignment: 'left', fontSize: 8, margin: [0, 10, 0, 0], italics: true },
            { text: `Page  ${currentPage} of ${pageCount}`, alignment: 'right', fontSize: 8, margin: [0, 10, 0, 0] }
          ]
        }
      ]
    };
  }
  };
}
